module.exports = {"id":"168651","name":"Ivan Rakitić","rating":"86","photo":"./data/images/photos/3/168651.png","club":{"name":"FC Barcelone","logo":"./data/images/clubs/FCBarcelone.png"},"positions":["MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IvanRakitic0.json
// module id = 1849
// module chunks = 0